export default __webpack_public_path__ + "static/media/covid-tracker.d9b5eaaa.png";